import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TheIssue from "@/pages/TheIssue";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TheIssue />} />
          <Route path="/clean" element={<Navigate to="/" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
